<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="false"
></app-st-banner>
<br><br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="'Reset Password Request'"></app-st-header-title>
      <br>
      <div class="container st-form">
        <div *ngIf="showSuccessMessages" class="container st-form text-success" #goUp>
          <div *ngFor="let successMsg of successMessages" class="alert alert-success" role="alert">
            <b>{{successMsg.field}}:</b> {{successMsg.detail}}
          </div>
          <br>
        </div>
        <div *ngIf="showErrorMessages" class="container st-form text-danger" #goUp>
          <app-st-span><b>Please validate the following: </b></app-st-span>
          <div *ngFor="let errorMsg of errorMessages" class="alert alert-danger" role="alert">
            <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
          </div>
          <br>
        </div>
        <div>
          <!--<app-st-input-text [idVal]="'username-text-id'" [label]="'User'"></app-st-input-text>-->
          <app-st-input-text [idVal]="'email-text-id'" [label]="'Email'"></app-st-input-text>
        </div>
        <br>
        <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
          <app-st-button [idVal]="'save-button-id'" [label]="'Submit'" [primary]="true"
                         (click)="onSubmit()"></app-st-button>
          <app-st-button-cancel [idVal]="'cancel-button-id'" [label]="'Cancel'" [primary]="false"
                         (click)="onCancel()"></app-st-button-cancel>
        </div>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
      </div>

    </div>
  </div>
</div>
